export function SignOutIcon(props: React.ComponentProps<'svg'>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" {...props}>
      <path d="M9.65,1.48a8.55,8.55,0,0,0-6.4,2.88A.81.81,0,0,0,3.33,5.5a.79.79,0,0,0,1.13-.07,6.91,6.91,0,1,1,.06,9.2.81.81,0,1,0-1.2,1.08A8.52,8.52,0,1,0,9.65,1.48Z" />
      <path d="M3.33,10a.81.81,0,0,0,.81.81h6.25L8.5,12.7a.81.81,0,0,0,0,1.14.8.8,0,0,0,1.14,0l3.27-3.27a.8.8,0,0,0,0-1.14L9.64,6.16a.8.8,0,0,0-1.14,0,.81.81,0,0,0,0,1.14l1.89,1.89H4.14A.81.81,0,0,0,3.33,10Z" />
    </svg>
  )
}
